export const FORM_1_COMMENTS = {
    isPayOnDelivery: "Дебіторська заборгованість з першого дня",
};

export const FORM_2_COMMENTS = {
    isPayOnDeliveryisSelfDelivery: "Оплата по факту",
    isPayOnDelivery: "Оплата в день доставки",
    isSelfDelivery: "Самостійний вивіз ТТ",
};
